<template>
  <div class="bg-white max-w-lg my-4">
    <a-list bordered :data-source="fundReports">
      <h3 slot="header" class="text-xl font-semibold">REPORTS</h3>
      <a-list-item slot="renderItem" slot-scope="item">
        <div class="w-full">
          <span
            @click="showReport(item.year, item.month)"
            class="cursor-pointer text-terracotta hover:underline"
          >
            {{ item.year }} - {{ item.month }}
          </span>
          <a-popconfirm
            title="Are you sure you want to delete this report?"
            ok-text="Yes"
            cancel-text="No"
            @confirm="deleteReport(item.year, item.month)"
          >
            <a-icon
              type="delete"
              title="Delete"
              class="mx-2 float-right cursor-pointer text-red-400"
            ></a-icon>
          </a-popconfirm>
          <a-icon
            type="edit"
            title="Edit"
            class="mx-2 float-right cursor-pointer text-terracotta"
            @click="editReport(item.year, item.month)"
          ></a-icon>
        </div>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  props: {
    fundId: {
      type: String,
      required: true,
    },
  },
  apollo: {
    fundReports: {
      query: gql`
        query GetFundReports($fundId: Uuid!) {
          fundReports(fundId: $fundId) {
            year
            month
          }
        }
      `,
      variables() {
        return {
          fundId: this.fundId,
        }
      },
    },
  },
  data() {
    return {
      fundReports: [],
    }
  },
  methods: {
    showReport(year, month) {
      this.$emit('showReport', { fundId: this.fundId, year, month })
    },
    editReport(year, month) {
      this.$emit('editReport', { fundId: this.fundId, year, month })
    },
    deleteReport(year, month) {
      this.$emit('deleteReport', { fundId: this.fundId, year, month })
    },
    reloadReports() {
      this.$apollo.queries.fundReports.refetch()
    },
  },
}
</script>

<style></style>
